import { useMemo} from 'react'
import getBBox, {} from '../components/RetroReflectPhase/getBBox'
import useCoords, {} from './useCoords'
import useLoadingDelay from './useLoadingDelay'
import useMenuPortal from './useMenuPortal'
import usePortal, {} from './usePortal'














/**
 * Wrapper around {@link usePortal} to display menus
 */
const useMenu = (
  preferredMenuPosition,
  options = {}
) => {
  const {onOpen, onClose, id, parentId, originCoords, menuContentStyles, menuContentRef} = options
  const isDropdown = !!options.isDropdown
  const {targetRef, originRef, coords, menuPosition} = useCoords(preferredMenuPosition, {
    originCoords
  })
  if (originCoords) {
    ;(originRef ).current = {getBoundingClientRect: () => originCoords} 
  }
  const {
    portal,
    closePortal,
    openPortal,
    portalStatus,
    terminatePortal,
    togglePortal,
    setPortalStatus
  } = usePortal({
    id,
    onOpen,
    onClose,
    parentId
  })
  const loadingWidth = useMemo(() => {
    if (options.loadingWidth) return options.loadingWidth
    const bbox = getBBox(originRef.current)
    return Math.max(40, bbox ? bbox.width : 40)
  }, [originRef.current /* eslint-disable-line react-hooks/exhaustive-deps */])
  const {loadingDelay, loadingDelayRef} = useLoadingDelay()
  const menuPortal = useMenuPortal(
    portal,
    targetRef,
    loadingWidth,
    coords,
    portalStatus,
    setPortalStatus,
    isDropdown,
    menuPosition,
    loadingDelayRef,
    menuContentStyles,
    menuContentRef
  )
  const menuProps = {portalStatus, closePortal, isDropdown}
  return {
    loadingDelay,
    loadingWidth,
    menuPortal,
    menuProps,
    openPortal,
    originRef,
    portalStatus,
    terminatePortal,
    togglePortal
  }
}

export default useMenu
